module.exports = __webpack_public_path__ + "img/add-arrival-requested-table-icon.ce36bf54.svg";